export default class ProfessionalDetails {
  static fromJSON(json) {
    return new ProfessionalDetails(json)
  }

  constructor(json) {
    this.sizeOfUsualEvents = json.sizeOfUsualEvents || null
    this.industries = json.industries || null
    this.numberOfEventsPerYear = json.numberOfEventsPerYear || null
    this.meRole = json.meRole || null
    this.numberOfReservationsPerYear = json.numberOfReservationsPerYear || null
    this.reasonForBooking = json.reasonForBooking || null
    this.typeOfBookingDestination = json.typeOfBookingDestination || null
    this.topCityDestinations = json.topCityDestinations || null
    this.typeOfHotelsBooked = json.typeOfHotelsBooked || null
    this.mostInterestedBrand = json.mostInterestedBrand || null
  }
}
